import { render } from "./HomeView.vue?vue&type=template&id=59a5ddcb&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=59a5ddcb&scoped=true&lang=css"

import exportComponent from "/home/runner/work/kv-cloud-pbx/kv-cloud-pbx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59a5ddcb"]])

export default __exports__